export default {
  promises: 'Обещания',
  givePromise: 'Дай обещание',
  promisesCompleted: 'Выполненные',
  promisesNew: 'Новые',
  promisesNotCompleted: 'Невыполненные',
  promisesOpen: 'Открытые',
  promiseNewTasksEmpty: 'Нет новых задач на обещания',
  promiseRepeatTasksEmpty: 'Нет повторных задач на обещания',
  promisesTasksEmpty: 'Нет задач на обещания',
  promisesEmpty: 'Нет обещаний',
  promiseTaskNew: 'новое',
  promiseTaskRepeat: 'Повторное обещание',
  promiseDebtSum: 'ДЗ:',
  promiseOverdueDebtSum: 'ПДЗ:',
  promiseInvoicesThisWeekSum: 'Фактуры к оплате на этой неделе:',
  promiseOverdueWithoutPromiseSum: 'Просроченные фактуры без обещания:',
  promiseOpenPromises: 'Открытые обещания',
  promiseUnfulfilledSum: 'Сумма невыполненного обещания:',
  promiseWillPay: 'Обещает оплатить',
  promiseContract: 'Договор',
  promiseSelectContract: 'Выберите договор',
  promisePaymentDate: 'Дата',
  promisePaymentSum: 'Сумма',
  promiseGoToCascade: 'Перейти в каскад',
  promiseAddMore: '+ обещание',
  promiseRemoveField: 'Удалить обещание',
  promiseCantAgree: 'Не смог договориться',
  promiseDoPromise: 'сохранить',
  promiseTaskDate: 'Дата задачи',
  promiseStatusInProgress: 'В работе',
  promiseStatusCompleted: 'Выполнено',
  promiseStatusOverdue: 'Просрочено',
  promiseStatusCantAgree: 'Не смог договориться',
  promiseStatusNew: 'Новое',
  promiseStatusNotCompleted: 'Не выполнено',
  promiseStatusPartiallyCompleted: 'Выполнено частично',
  promiseStatusFullyCompleted: 'Выполнено полностью',
  promiseCreated: 'Обещание создано',
  promiseCantAgreeCreated: 'Создана задача на ДПП',
  promiseValidationSumRequired: 'Укажите сумму платежа',
  promiseValidationSumPositive: 'Сумма должна быть больше нуля',
  promiseValidationDateRequired: 'Укажите дату платежа',
  promiseValidationDateFuture: 'Дата не может быть в прошлом',
  promiseValidationContractRequired: 'Выберите договор',
  promiseValidationContractUnique: 'Обещание по этому договору уже добавлено',
  promiseFilterAll: 'Все',
};
